import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { Review } from 'src/models/review.model';
import { ReviewService } from 'src/services/review.service';
import { PaginationInstance } from 'ngx-pagination';
import { AuthService } from 'src/services/guard/auth.service';
import { _ } from 'ngx-translate-extract';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss']
})
export class ReviewsComponent extends BaseComponent implements OnInit {

  reviews: Review[];
  average: number;
  modalRef: BsModalRef;
  reviewModel: Review;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 5,
    currentPage: 1
  };

  constructor(
    private reviewService: ReviewService,
    translate: TranslateService,
    authService: AuthService,
    private modalService: BsModalService,
    private toast: ToastrService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(translate, authService, deviceDetectorService, route);
    this.langChange.subscribe(() => this.ngOnInit());
  }

  ngOnInit(): void {
    this.reviewService.getReviews().subscribe(
      reviews => {
        this.reviews = reviews.sort((a, b) => <any>new Date(b.createdAt) - <any>new Date(a.createdAt));
        this.calculateAverage();
      }
    );
  }

  calculateAverage() {
    let total = 0;
    this.reviews.forEach(x => total += x.evaluation);
    this.average = total / this.reviews.length;
  }

  getAverageString() {
    return this.average.toFixed(1);
  }

  reviewModal(template: TemplateRef<any>) {
    this.reviewModel = new Review();
    this.reviewModel.evaluation = 0;
    this.modalRef = this.modalService.show(template);
  }

  setRating(rating: number) {
    this.reviewModel.evaluation = rating;
  }

  saveReview() {
    this.reviewModel.stayStartDate = new Date(this.reviewModel.stayStartDate);
    console.log(this.reviewModel);
    this.reviewModel.stayStartDate.setHours(8, 0, 0, 0);
    this.reviewService.addReview(this.reviewModel).subscribe(
      () => this.toast.success('Votre commentaire a été publié!'),
      err => {
        console.error(err);
        this.toast.error('An error occured');
      },
      () => {
        this.ngOnInit();
        this.close();
      }
    );
  }

  close() {
    this.modalRef.hide();
  }

}
